<template>
  <div class="accountInfo isBackground">
    <Header :title="title" :right-content="rightContent" />
    <div id="content">
      <div class="layout">
        <div class="infoCon">
          <ul>
            <li><p>账户号码</p><p>{{ accountNo }}</p></li>
            <li><p>账户级别</p><p>{{ accountLevelList[currentAcc] }}</p></li>
            <li> <p>升级成为</p><a>{{ accountLevelList[newAccountLevel] }}</a></li>
          </ul>
          <div class="submit" @click="popOrSubmit"><span>提交申请</span></div>
          <div class="errMessage"><span>{{ errMessageTxt }}</span></div>
          <div class="accExplain">
            <p>账户升级须知：</p>
            <p>1）账号升级适用于您账号下所有交易平台， 请确保您所有平台的账户里没有持仓与挂单。</p>
            <p>2）客服会于您申请后的下一个工作日中午前审批处理。</p>
            <p>3）审批后，您只需重新登入即可享受更佳的投资体验。</p>
            <p>{{ altFlavors.includes(flavor) ? "" : "4）级别调整或会影响相关活动权益，操作前请详加了解。经提交申请则视同确认放弃， 如：巴菲特级别不享有推荐有奖活动。" }}</p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="confirmUpgrade" class="popFixed">
      <div class="masking" @click="confirmUpgrade=false" />
      <div class="tcCon">
        <div class="item">
          <span>账户升级说明</span>
          <p>提醒您，此升级会影响您活动权益。</p>
        </div>
        <div class="btnCon">
          <span @click="openLive800">联系客服</span>
          <span @click="submit">确认升级</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
require('@/assets/css/accInfo.css')
import Header from '@/view/module/Header.vue'
import api from '@/plugins/api'
import { mapState } from 'vuex'
export default {
  name: 'AccUpgrade',
  components: { Header },
  computed: {
    ...mapState(['platform', 'platformName', 'gts2AccountId','accountNo'])
  },
  data() {
    return {
      title: '账户升级',
      rightContent: 'isNo',
      accountLevelList: JSON.parse(process.env.VUE_APP_LEVEL),
      currentAcc: this.$route.query.accountLevel || '',
      newAccountLevel: '',
      errMessageTxt: '',
      confirmUpgrade: false,
      flavor: this.$route.query.flavor,
      altFlavors: process.env.VUE_APP_ALT_FLAVORS.split(',')
    }
  },
  mounted() {
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
    this.getAccountLevel()
  },
  activated() {
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
  },
  methods: {
    popOrSubmit() {
      switch (this.currentAcc) {
        case 'MIN':
          this.submit()
          break
        case 'VIP':
          this.submit()
          break
        default:
          this.confirmUpgrade = !this.confirmUpgrade
      }
    },
    getAccountLevel() {
      api.getAccountLevelByGts2AccountId(this.gts2AccountId).then(res => {
        if (res.status == 200 && res.data.code == 200) {
          for (const i in res.data.data) {
            this.newAccountLevel = i
          }
        }
      })
    },
    submit() {
      const data = {
        gts2AccountId: this.gts2AccountId,
        oldAccountLevel: this.currentAcc,
        newAccountLevel: this.newAccountLevel,
        platform: this.platform
      }
      this.$bus.$emit('loading', false)
      api.accountUpgrade(this.$qs.stringify(data)).then(res => {
        if (res.status == 200 && res.data.code == 200) {
          this.errMessageTxt = ''
          this.$router.replace({ path: '/home/success', query: { type: 1 }})
        } else {
          this.$bus.$emit('loading', true)
          this.errMessageTxt = res.data.code_desc
          alert(res.data.code_desc)
          this.confirmUpgrade = false
        }
      })
    },
    openLive800() {
      var url = `https://onlinecs.cffx139.net/Web/im.aspx?_=t&accountid=137707&visitorid=${new Date().getTime()}`
      var left = (screen.width / 2) - (600 / 2)
      var top = (screen.height / 2) - (400 / 2)
      window.open(url,
        'DescriptiveWindowName',
        'resizable,scrollbars=yes,status=1,width=800, height=550, top=' + top + ', left=' + left)
    }
  }
}
</script>
